"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = _interopRequireDefault(require("@vds-core/icons"));

var _data = _interopRequireDefault(require("./data.json"));

var propTypes = {
  /**
   * JSON File with paths for new Icons for 1.0.
   */
  data: _propTypes["default"].object,

  /**
   * Boolean to change Icon stroke from default of 1px to 2px.
   */
  medium: _propTypes["default"].bool
};
var defaultProps = {
  data: _data["default"],
  medium: false
};

var Icon = function Icon(props) {
  return /*#__PURE__*/_react["default"].createElement(_icons["default"], (0, _extends2["default"])({}, props, {
    data: _data["default"],
    hasStroke: false,
    medium: false,
    focusState: false,
    focused: false
  }));
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
var _default = Icon;
exports["default"] = _default;